import { useSelector } from 'react-redux';

import { getIsExpenseMigratedToTransferScheduling } from 'src/core/selectors/globalSelectors';

// TODO@expense-migration@finance-ops: remove this selector when the migration is done
export const useIsExpenseMigratedToTransferScheduling = () => {
  return useSelector(getIsExpenseMigratedToTransferScheduling);
};
